<template>
  <div class="advantageService">
    <!-- <div>
      <div class="highLightTitle fz16">
        “代理人服务协议插上专业的翅膀”
      </div>
    </div>
    <div>
      <img src="../assets/images/picture_14.png" alt="">
    </div> -->
    <div class="colorTitle">
      <span>///</span> 壹心好赔 <span>///</span>
    </div>
    <div class="compText bl">
      壹心好赔——让您无后顾之忧
    </div>
    <div>
      <img src="../assets/images/picture_15.png" alt="">
    </div>
    <div class="colorTitle">
      <span>///</span> 理赔法律服务承诺 <span>///</span>
    </div>
    <!-- <div class="compText bl">
      资料齐全且理赔金额≤5000元案件，可申请7天之内先行赔付；复杂案件，30天之内出具理赔结论。
    </div> -->
    <div style="text-align: center;">
      <img style="width:560px;" src="../assets/images/picture_16.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'advantageService',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.advantageService {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 110px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }

  .colorTitle {
    margin-top: 40px;
  }
}
</style>